import {
  UserListView,
  UserNewView,
  UserEditView,
  UserShowView,
} from '@/views/authenticated/users';
import { Role } from '@/const';

export default [
  {
    path: '/users',
    name: 'app_user_list',
    meta: { title: 'Users' },
    component: UserListView,
  },
  {
    path: '/users/new',
    name: 'app_user_new',
    meta: {
      title: 'Add a User',
      allowedRoles: [Role.MunicipalAdministrator],
    },
    component: UserNewView,
  },
  {
    path: '/users/:user/edit',
    name: 'app_user_edit',
    meta: { title: 'Edit User' },
    component: UserEditView,
  },
  {
    path: '/users/:user/show',
    name: 'app_user_show',
    meta: { title: 'Show User' },
    component: UserShowView,
  },
];
